// src/pages/Wallet/hooks/useNetworkManagement.js
import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Hook to manage network visibility
 * Handles hiding/showing networks in the network selector
 */
export const useNetworkManagement = () => {
  const { t } = useTranslation();
  
  // Network management state with localStorage persistence
  const [hiddenNetworks, setHiddenNetworks] = useState(() => {
    try {
      const saved = localStorage.getItem('hiddenNetworks');
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      console.error('Error loading hidden networks from localStorage:', e);
      return [];
    }
  });

  // Toggle network visibility
  const toggleNetworkVisibility = useCallback((networkKey) => {
    if (!networkKey) return;
    
    setHiddenNetworks(prev => {
      if (prev.includes(networkKey)) {
        // Remove from hidden list
        return prev.filter(key => key !== networkKey);
      } else {
        // Add to hidden list
        return [...prev, networkKey];
      }
    });
  }, []);

  // Restore all hidden networks
  const restoreAllNetworks = useCallback(() => {
    setHiddenNetworks([]);
  }, []);

  // Persist hidden networks to localStorage
  useEffect(() => {
    try {
      localStorage.setItem('hiddenNetworks', JSON.stringify(hiddenNetworks));
    } catch (e) {
      console.error('Error saving hidden networks to localStorage:', e);
    }
  }, [hiddenNetworks]);

  return {
    hiddenNetworks,
    toggleNetworkVisibility,
    restoreAllNetworks
  };
};